import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";


const CustomFormFieldsList = Loadable(
  lazy(() =>
    import("./CustomFormFieldsList").then(({ CustomFormFieldsList }) => ({
      default: CustomFormFieldsList,
    }))
  )
);

export const customFormFieldsRoutes = [
  {
    path: `/settings/custom-form-fields`,
    exact: true,
    element: (
      <AuthorizedRoute  moduleKeys={[MODULE_IDS.CUSTOM_FORM_FIELDS]} allowFullAccess={true}>
        <CustomFormFieldsList />
      </AuthorizedRoute>
    ),
  },
]
